import { gql } from '@apollo/client';

const GET_CONFIG_PROFILES = gql`
query getConfigProfiles {
    configProfiles {
        _id
        PayloadDisplayName
        PayloadDescription
        PayloadOrganization
        PayloadIdentifier
        PayloadUUID
        PayloadVersion
        MobileConfigData
        hasEditorDocument
    }
}
`

export { GET_CONFIG_PROFILES };
